// src/lib/supabase.js
import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://qqexkuqcaxbyytmhlnhx.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFxZXhrdXFjYXhieXl0bWhsbmh4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM3NjY1NzgsImV4cCI6MjA2OTM0MjU3OH0.zroarwqS8uYBhe6CN87yq9aZyfHoEOpWAFmeoG4mdSE';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
    redirectTo: 'https://www.clingfilm.ai'
  },
  global: {
    headers: {
      'apikey': SUPABASE_ANON_KEY
    }
  }
});